import apiClient from './client';

// Get all messages
export const getMessages = async () => {
  const response = await apiClient.get('/messages/');
  return response.data;
};

// Get message by ID
export const getMessage = async (messageId) => {
  const response = await apiClient.get(`/messages/${messageId}/`);
  return response.data;
};

// Create new message (Send to customer)
export const createMessage = async (payload) => {
  if (payload instanceof FormData) {
    const response = await apiClient.post('/inbox/send-message/', payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
  const response = await apiClient.post('/inbox/send-message/', {
    contact_id: payload.contact || payload.contact_id,
    message: payload.text || payload.message || '',
    media_url: payload.media_url || '',
  });
  return response.data;
};

// Update message
export const updateMessage = async (messageId, payload) => {
  const response = await apiClient.patch(`/messages/${messageId}/`, payload);
  return response.data;
};

// Delete message
export const deleteMessage = async (messageId) => {
  const response = await apiClient.delete(`/messages/${messageId}/`);
  return response.data;
};

// Get messages for a specific contact
export const getContactMessages = async (contactId, page = 1) => {
  try {
    const response = await apiClient.get('/inbox/messages/', {
      params: { contact_id: contactId, page_size: 50, page }
    });
    return response.data;
  } catch (err) {
    console.error('Error fetching contact messages:', err);
    return { results: [], count: 0 };
  }
};
